import React from "react";
import TextField from "@material-ui/core/TextField";

type Props = {
  value: Record<string, unknown>;
  onChange: (newValue: Record<string, unknown>) => void;
};

export default function TestValue({value, onChange}: Props) {
  return (
    <TextField
      value={value.text}
      onChange={event => onChange({text: event.target.value})}
      label="/abc/"
      variant="outlined"
    />
  );
}
